import React, { useState } from 'react';

const Banner = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section className="flex flex-col sm:flex-col lg:flex-row justify-between items-center bg-[#DD7C88] py-12 px-12">
      <div className="banner-text text-center lg:text-left">
        <h2 className="text-4xl text-black font-bold m-0 mb-4">
          La Ronde Saubenoise
        </h2>
        
        <div className="space-y-2">
          <p className="px-3 py-2 rounded-md bg-green-500 text-white font-medium">
            <a 
              href="https://www.openrunner.com/route-details/9105701" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:text-black"
            >
              Circuit 27 km 164 m D+ n° 9105701
            </a>
          </p>
          <p className="px-3 py-2 rounded-md bg-blue-500 text-white font-medium">
            <a 
              href="https://www.openrunner.com/route-details/22563458" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:text-black"
            >
              Circuit 71 km 811 m D+ n° 22563458
            </a>
          </p>
          <p className="px-3 py-2 rounded-md bg-red-500 text-white font-medium">
            <a 
              href="https://www.openrunner.com/route-details/22563452" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:text-black"
            >
              Circuit 94 km 1024 m D+ n° 22563452
            </a>
          </p>
          <p className="px-3 py-2 rounded-md bg-amber-700 text-white font-medium">
            <a 
              href="https://www.openrunner.com/route-details/24713856" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:text-black"
            >
              Circuit 47 km 721 m D+ n° 24713856
            </a>
          </p>
        </div>
      </div>

      <div
        className="banner-image mt-8 lg:mt-0"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src={isHovered ? "/picture/jersey_rear.png" : "/picture/jersey_front.png"}
          alt="Maillot Saubens Cyclo 31"
          className="h-[350px] w-auto object-contain"
        />
      </div>
    </section>
  );
};

export default Banner;
